<template>
  <div class="form_row" :class="thisClassNames">
    <div class="form_row__title t-label t-label--dark">
      <slot name="title"></slot>

      <template v-if="!$slots.title">
        {{ title }}
      </template>
    </div>

    <div class="form_row__body">
      <slot></slot>
    </div>

    <div class="form_row__illustration_row" v-if="$slots.illustration">
      <slot name="illustration"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleStyle: {
      type: String,
      default: "block",
      validator(val) {
        return ["inline", "block"].includes(val);
      },
    },
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    thisClassNames() {
      return "form_row--title_" + this.titleStyle;
    },
  },
};
</script>

<style lang="scss">
$form_row__title-width: 232px;

.form_row {
  &__title {
    padding-right: 1em;
    width: $form_row__title-width;
    flex: 0 0 $form_row__title-width;
    text-align: right;
    line-height: 32px;
  }

  &__illustration_row {
    // display: flex;
    // justify-content: flex-end;
    margin-top: 42px;
    width: 330px;
    margin-left: auto;

    img {
      width: 330px;
    }
  }

  //modifiers
  &--title_inline {
    display: flex;
    margin-bottom: 0;

    .form_row__body {
      flex-grow: 1;
    }

    .radio_group:first-child {
      margin-top: 7px;
    }

    .checkbox:first-child {
      margin-top: 7px;
    }
  }

  &--title_block {
    .form_row__title {
      margin-bottom: 13px;
    }

    .form_row__body {
      margin-left: $form_row__title-width;
    }
  }

  &:not(:last-child) {
    margin-bottom: 26px;
  }

  &:last-child {
    margin-bottom: 12px;
  }
}
</style>
